// src/pages/tienda/Carrito.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import Breadcrumb from '../../components/Breadcrumb';

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);

export default function Carrito() {
  const { items, total, vaciar, cambiarCantidad, quitar } = useCart();
  const navigate = useNavigate();

  if (!items.length) return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Carrito' }]} />
      <div style={{ maxWidth:600, margin:'80px auto', padding:'0 24px', textAlign:'center' }}>
        <div style={{ fontSize:80, marginBottom:20 }}>🛒</div>
        <h2 style={{ fontFamily:'Playfair Display,serif', fontSize:28, color:'#1e401f', marginBottom:12 }}>
          Tu carrito esta vacio
        </h2>
        <p style={{ fontSize:15, color:'#7a8a7a', marginBottom:28 }}>
          Agrega productos naturales para tu familia y cuida el planeta con cada compra.
        </p>
        <Link to="/" className="btn btn-primary" style={{ padding:'12px 32px', fontSize:15 }}>
          Ver productos
        </Link>
      </div>
    </div>
  );

  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Carrito' }]} />

      <div style={{ maxWidth:1000, margin:'0 auto', padding:'40px 24px 80px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:28, flexWrap:'wrap', gap:12 }}>
          <h1 style={{ fontFamily:'Playfair Display,serif', fontSize:32, color:'#1e401f', margin:0 }}>
            Mi carrito
            <span style={{ fontSize:16, fontWeight:400, color:'#8a9a8a', marginLeft:10 }}>
              ({items.reduce((s,i) => s + i.cantidad, 0)} productos)
            </span>
          </h1>
          <button onClick={vaciar} style={{ background:'none', border:'none', color:'#e76f51', fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'Inter,sans-serif' }}>
            Vaciar carrito
          </button>
        </div>

        <div className="carrito-grid" style={{ display:'grid', gridTemplateColumns:'1fr 340px', gap:28, alignItems:'flex-start' }}>

          {/* LISTA DE PRODUCTOS */}
          <div className="card">
            <div className="card-body" style={{ padding:0 }}>
              {items.map((item, idx) => (
                <div key={item.id} style={{
                  display:'grid',
                  gridTemplateColumns:'80px 1fr auto',
                  gap:16,
                  padding:'20px 24px',
                  borderBottom: idx < items.length-1 ? '1px solid rgba(44,94,46,0.08)' : 'none',
                  alignItems:'center'
                }}>
                  {/* Imagen */}
                  <div style={{ width:80, height:80, borderRadius:12, overflow:'hidden', background:'#e8f3e6', flexShrink:0 }}>
                    {item.imagen_principal
                      ? <img src={item.imagen_principal} alt={item.nombre} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                      : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:32 }}>🌿</div>}
                  </div>

                  {/* Info */}
                  <div style={{ minWidth:0 }}>
                    <div style={{ fontFamily:'Playfair Display,serif', fontWeight:700, fontSize:16, color:'#1e401f', marginBottom:4 }}>
                      {item.nombre}
                      {item.variaciones && item.variaciones.length > 0 && (
                        <div style={{ fontSize:11, color:'var(--ink-faint)', marginTop:2 }}>
                          {item.variaciones.map(v => v.tipo + ': ' + v.valor).join(' · ')}
                        </div>
                      )}
                    </div>
                    {item.descripcion_corta && (
                      <div style={{ fontSize:12, color:'#8a9a8a', marginBottom:10, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                        {item.descripcion_corta}
                      </div>
                    )}
                    {/* Controles de cantidad */}
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:4, border:'1.5px solid rgba(44,94,46,0.2)', borderRadius:10, padding:'4px 8px', background:'#fff' }}>
                        <button onClick={() => cambiarCantidad(item._key || item.id, item.cantidad-1)} style={{ width:28, height:28, border:'none', background:'none', cursor:'pointer', fontWeight:700, fontSize:16, color:'#2c5e2e', display:'flex', alignItems:'center', justifyContent:'center' }}>-</button>
                        <span style={{ minWidth:28, textAlign:'center', fontWeight:700, fontSize:15, color:'#1e401f' }}>{item.cantidad}</span>
                        <button onClick={() => cambiarCantidad(item._key || item.id, item.cantidad+1)} style={{ width:28, height:28, border:'none', background:'none', cursor:'pointer', fontWeight:700, fontSize:16, color:'#2c5e2e', display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
                      </div>
                      <button onClick={() => quitar(item._key || item.id)} style={{ background:'none', border:'none', color:'#e76f51', cursor:'pointer', fontSize:13, fontWeight:700, fontFamily:'Inter,sans-serif' }}>
                        Eliminar
                      </button>
                    </div>
                  </div>

                  {/* Precio */}
                  <div style={{ textAlign:'right', flexShrink:0 }}>
                    <div style={{ fontWeight:900, fontSize:18, color:'#2c5e2e', fontFamily:'Inter,sans-serif' }}>
                      {fmtCOP(item.precio * item.cantidad)}
                    </div>
                    {item.cantidad > 1 && (
                      <div style={{ fontSize:12, color:'#8a9a8a', marginTop:2 }}>
                        {fmtCOP(item.precio)} c/u
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RESUMEN */}
          <div className="card" style={{ position:'sticky', top:96 }}>
            <div className="card-header">
              <span className="card-title">Resumen</span>
            </div>
            <div className="card-body">
              {/* Subtotales */}
              <div style={{ marginBottom:16 }}>
                {items.map(item => (
                  <div key={item.id} style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:6, color:'#5a6e5a' }}>
                    <span style={{ flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', paddingRight:8 }}>{item.nombre} x{item.cantidad}</span>
                    <span style={{ fontWeight:600, flexShrink:0 }}>{fmtCOP(item.precio * item.cantidad)}</span>
                  </div>
                ))}
              </div>

              <div style={{ borderTop:'1px solid rgba(44,94,46,0.1)', paddingTop:14, marginBottom:14 }}>
                <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:6 }}>
                  <span style={{ color:'#7a8a7a' }}>Subtotal</span>
                  <span style={{ fontWeight:700 }}>{fmtCOP(total)}</span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:6 }}>
                  <span style={{ color:'#7a8a7a' }}>Envio</span>
                  <span style={{ fontWeight:600, color:'#2c5e2e' }}>Se calcula al pagar</span>
                </div>
                {total >= 100000 && (
                  <div style={{ background:'#e8f3e6', borderRadius:8, padding:'8px 12px', fontSize:12, color:'#2c5e2e', fontWeight:700, marginTop:8 }}>
                    Califica para envio gratis
                  </div>
                )}
              </div>

              <div style={{ display:'flex', justifyContent:'space-between', fontWeight:900, fontSize:22, marginBottom:20, color:'#1e401f' }}>
                <span>Total</span>
                <span style={{ color:'#2c5e2e' }}>{fmtCOP(total)}</span>
              </div>

              <button
                className="btn btn-primary"
                style={{ width:'100%', padding:14, fontSize:16, marginBottom:10 }}
                onClick={() => navigate('/checkout')}
              >
                Proceder al pago →
              </button>

              <Link to="/" style={{ display:'block', textAlign:'center', fontSize:13, color:'#7a8a7a', marginTop:8 }}>
                Seguir comprando
              </Link>

              {/* Badges de confianza */}
              <div style={{ marginTop:20, paddingTop:16, borderTop:'1px solid rgba(44,94,46,0.08)', display:'flex', justifyContent:'center', gap:12, flexWrap:'wrap' }}>
                {['🔒 Pago seguro', '🌿 100% Natural', '🚚 Envio Colombia'].map(b => (
                  <span key={b} style={{ fontSize:11, color:'#7a8a7a', fontWeight:600 }}>{b}</span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* VERSION MOVIL: el resumen va abajo en una sola columna */}

      </div>
    </div>
  );
}
